/**
 * Abuse-report UI types and constants.
 *
 * Real persistence lives in Supabase `reports` (migration 00001) — see
 * `frontend/src/data/reports.ts` for the hooks. Anonymous submission is
 * routed through the upload-handler contributor session endpoints.
 */

export const REPORT_REASONS = [
  { id: 'inappropriate', label: 'Inappropriate content' },
  { id: 'spam', label: 'Spam or scam' },
  { id: 'harassment', label: 'Harassment or bullying' },
  { id: 'copyright', label: 'Copyright violation' },
  { id: 'other', label: 'Other' },
] as const

export type ReportReason = typeof REPORT_REASONS[number]['id']

export type ReportStatus = 'pending' | 'reviewed' | 'resolved' | 'dismissed'

// UI-shape report (adapted from the Supabase row by data/reports.ts).
export interface AbuseReport {
  id: string
  photoId?: string
  dropId: string
  dropName: string
  galleryToken?: string
  reason: ReportReason
  description?: string
  reporterSession: string
  status: ReportStatus
  createdAt: Date
  reviewedAt?: Date
  reviewedBy?: string
  resolution?: string
}
